/**
 * 渠道开关（与业务里 generateContent 的分发配合使用）：
 *
 * - **video**：在 **Pollo** 与 **官方直连**（如火山方舟）之间选择，见 getOfficialVideoProfile。
 * - **image / music**：主链路为 **AllAll** 时，请把 imageDefault、musicDefault 设为 **'allall'**；
 *   仅表示「这一类不走本文件的 Pollo/官方二选一里的 Pollo」；实际请求仍由 isAllallImageModel、Suno 等逻辑走 AllAll。
 *   若某图/音模型要接「官方直连」，在 **modelOverrides.image / modelOverrides.music** 里写对应 modelId → **'official'**（并配置 OFFICIAL_IMAGE_MODEL_PROFILE 等）。
 *
 * 取值：**'pollo'** | **'official'** | **'allall'**
 *（allall 仅用于标明图/音主链路为 AllAll；getOfficial* 仅在解析结果为 **official** 时才会走直连模块。）
 *
 * 生效优先级：
 * lockedModelOverrides.{video|image|music}[modelId]（不可切换，最高优先）
 * → modelOverrides.{video|image|music}[modelId]（可切换）
 * → 对应 media 的 Default
 * → globalDefault
 *
 * 密钥与域名仍在 .env（如 VUE_APP_OFFICIAL_VOLC_SEEDANCE_VIDEO_*）。
 *
 * @type {{
 *   globalDefault: 'pollo'|'official'|'allall',
 *   videoDefault: 'pollo'|'official'|'allall',
 *   imageDefault: 'pollo'|'official'|'allall',
 *   musicDefault: 'pollo'|'official'|'allall',
 *   modelOverrides: {
 *     video: Record<string, 'pollo'|'official'|'allall'>,
 *     image: Record<string, 'pollo'|'official'|'allall'>,
 *     music: Record<string, 'pollo'|'official'|'allall'>
 *   },
 *   lockedModelOverrides: {
 *     video: Record<string, 'pollo'|'official'|'allall'>,
 *     image: Record<string, 'pollo'|'official'|'allall'>,
 *     music: Record<string, 'pollo'|'official'|'allall'>
 *   }
 * }}
 */
export var OFFICIAL_CHANNEL_SWITCH = {
  globalDefault: 'pollo',
  /** 视频：默认 Pollo；与官方二选一 */
  videoDefault: 'pollo',
  /** 图片：主链路 AllAll（本项仅为语义配置；实际走 AllAll 由 api 路由决定） */
  imageDefault: 'allall',
  /** 音乐：主链路 AllAll */
  musicDefault: 'allall',
  /** 不可切换模型：固定渠道（例如 seedream-5） */
  lockedModelOverrides: {
    video: {},
    image: {
      'seedream-5': 'official',
      'flux-2': 'official',
      'gpt-image-1-5': 'official',
      'qwen-image-2-0-pro': 'official',
      'z-image-turbo': 'official',
      'nano-banana-2': 'official'
    },
    music: {}
  },
  /** 按类型覆盖：video / image / music 下再写逻辑 modelId（如 seedance-1-5-pro、seedream-4） */
  modelOverrides: {
    video: {
      'seedance-1-5-pro': 'official',
      'wan-2-2': 'official',
      'wan-2-5': 'official',
      'wan-2-6': 'official',
      'sora-2': 'official',
      'wan-animate': 'official'
    },
    image: {
      'seedream-4': 'official',
      'flux-pro-1-1-ultra': 'allall'
    },
    music: {}
  }
}
